import { mapActions } from 'vuex'
import { NAMESPACE } from '../store'
import { NAMESPACE as APP_NAMESPACE } from '@argon/app/store'
export default {
  data() {
    return {
      sending: false,
      verifying: false
    }
  },
  methods: {
    ...mapActions(NAMESPACE, ['getProfile', 'resendVerification']),
    ...mapActions(APP_NAMESPACE, ['setSnackMessage']),
    resend() {
      this.sending = true
      this.resendVerification()
        .then(() => {
          this.sending = false
          this.setSnackMessage({ string: 'verificationLinkSent' })
        })
        .catch(() => {
          this.sending = false
        })
    },
    verify() {
      this.verifying = true
      this.getProfile({})
        .then(() => {
          this.verifying = false
          this.setSnackMessage({ string: 'profileFetched' })
        })
        .catch(() => {
          this.verifying = false
        })
    }
  }
}
